import { useState } from 'react';
import { Search } from '@customerio/pluma-components/react';

const PLACEHOLDER = 'Find by name or description';

type BroadcastsSearchProps = {
  /** The search the list is showing. */
  value: string;
  /** Applies a search, on Enter or when the field is cleared. */
  onSearch: (value: string) => void;
};

/**
 * The search box both tabs share. What is typed is held here until Enter applies it, so the
 * list doesn't reload per keystroke. The caller keys this on the applied search, so a tab link
 * or Back that changes it starts the field over.
 */
export function BroadcastsSearch({ value, onSearch }: BroadcastsSearchProps) {
  const [draft, setDraft] = useState(value);

  return (
    <Search
      id="broadcast_search"
      value={draft}
      placeholder={PLACEHOLDER}
      ariaLabel={PLACEHOLDER}
      onSearchInput={setDraft}
      onSearch={onSearch}
      shouldSearchOnEnter
      shouldSearchOnClear
    />
  );
}
